/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Task_CreateInputs */

const en_task_create = /** @type {(inputs: Task_CreateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Create task`)
};

const pt_br2_task_create = /** @type {(inputs: Task_CreateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Criar atividade`)
};

/**
* | output |
* | --- |
* | "Create task" |
*
* @param {Task_CreateInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const task_create = /** @type {((inputs?: Task_CreateInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Task_CreateInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_task_create(inputs)
	return pt_br2_task_create(inputs)
});